import { useState } from "react";
import styles from "./StarRating.module.css";

interface StarRatingProps {
  value: number;
  onChange: (val: number) => void;
  max?: number;
}

export function StarRating({ value, onChange, max = 5 }: StarRatingProps) {
  const [hover, setHover] = useState(0);

  return (
    <div className={styles.stars}>
      {Array.from({ length: max }, (_, i) => {
        const ratingValue = i + 1;
        return (
          <span
            key={i}
            className={`${styles.star} ${ratingValue <= (hover || value) ? styles.filled : ""}`}
            onClick={() => onChange(ratingValue)}
            onMouseEnter={() => setHover(ratingValue)}
            onMouseLeave={() => setHover(0)}
          >
            ★
          </span>
        );
      })}
    </div>
  );
}
